import cx from 'classnames';
import { v4 as uuid } from 'uuid';
import { Conditional } from '@cat-ecom/pcc-components';
import { CatSkeleton } from 'components/blocks-components';
import { ProductCardHeading } from '../product-card-heading';
import { ProductCardGridLoaderProps } from '../types';
import styles from './product-card-loader.module.scss';

export const ProductCardGridLoader = ({
  isHeaderLoader = true,
  title
}: ProductCardGridLoaderProps) => {
  return (
    <>
      <Conditional test={isHeaderLoader}>
        <div className="d-flex justify-content-between mb-1">
          <ProductCardHeading title={title} />
          <CatSkeleton
            width="115px"
            className="px-0 py-1 mt-3 mt-blg-0 p-blg-3"
          />
        </div>
      </Conditional>
      <section className={styles['product-card-grid-loader-wrapper']}>
        {Array(4)
          .fill(0)
          .map(() => (
            <div
              key={uuid()}
              className={cx(
                'card d-lg-block d-flex flex-row',
                styles['products-cards']
              )}
            >
              <div className="mb-2">
                <div className="d-none d-lg-block">
                  <CatSkeleton size="lg" />
                  <CatSkeleton size="lg" />
                  <CatSkeleton />
                </div>
                <div className="d-lg-none">
                  <CatSkeleton size="lg" width="72px" />
                  <CatSkeleton size="sm" width="72px" />
                </div>
              </div>

              <div className="w-100">
                <CatSkeleton className="d-block mb-2" size="sm" />
                <CatSkeleton size="sm" className="d-block mb-2 w-50" />
                <CatSkeleton className="d-block mb-2" />
                <CatSkeleton size="sm" />
              </div>
            </div>
          ))}
      </section>
    </>
  );
};
